import Header from '../Header'
import Footer from '../Footer'
import ContactDetails from './components/ContactDetails'

const ContactView = () => {
  return (
    <div className="w-full bg-gradient-to-b from-purple-50/15 to-purple-100 h-[100svh] overflow-scroll snap-y snap-mandatory">
      <div className="snap-center">
        <Header />
        <ContactDetails />
        <Footer />
      </div>
    </div>
  )
}

export default ContactView
